import React from "react";
import Swal from "sweetalert2";
import { getWithAuth, putWithAuth } from "../../../api/api";
import { API_URLS } from "../../../api/apiConfig";

class ModalDeactivateUser extends React.Component {
  /**
   * userId: string | number
   * fetchData: () => void   // refresca la lista tras desactivar
   * userLabel?: string      // opcional: mostrar email/nombre en el aviso
   */
  static handleDeactivate = async (userId, fetchData, userLabel = "") => {
    const callApi = async (id) => {
      try {
        await putWithAuth(API_URLS.DEACTIVATE_USER(id));
      } catch (error) {
        console.error("Error deactivating user:", error);
        throw error;
      }
    };

    const result = await Swal.fire({
      title: "¡Cuidado!",
      html: `
        Vas a <b>eliminar/desactivar</b> un usuario${
          userLabel ? `: <b>${userLabel}</b>` : ""
        }.<br/>
        Esta acción puede impedir su acceso a la plataforma.
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar / Desactivar usuario",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-sm btn-primary",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: "Procesando...",
          text: "Por favor, espera mientras desactivamos el usuario",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });

        await callApi(userId);

        await Swal.fire({
          icon: "success",
          title: "Usuario desactivado",
          text: "El usuario se ha desactivado correctamente.",
          confirmButtonText: "Aceptar",
          customClass: { confirmButton: "btn btn-sm btn-primary" },
        });

        if (fetchData) fetchData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error al desactivar el usuario",
          text: "Hubo un problema desactivando el usuario. Inténtalo de nuevo más tarde.",
        });
      }
    }
  };

  render() {
    return null;
  }
}

export default ModalDeactivateUser;
